export default __webpack_public_path__ + "assets/images/Payment_08.491f39.png";